export abstract class Validator {
    public abstract validate: (
        value: any,
        data?: { [key: string]: any }
    ) => { text: string }[];
}
